import React, { } from 'react';

import styled from "styled-components";
import { Card, Typography } from "@mui/material";

import LocalStorageHelper from "../../Utilities/Helpers/LocalStorageHelper";
import DateHelper from "../../Utilities/Helpers/DateHelper";

type CustomExpirationDateInterface = {
    expiryDate?: string | Date | null;
    isFromDetails?: boolean;
};

const ExpirationDateContainer = styled(Card) <{ $darkMode?: boolean; $isFromDetails?: boolean; }>`
    background: transparent !important;
    border: none;
    border-radius: 0px !important;
    box-shadow: none !important;
    display: flex;

    .expirationDate {
        font-weight: ${(props) => props.$isFromDetails ? '500' : '400'} !important;
        font-size: ${(props) => props.$isFromDetails ? '16px' : '13px'} !important;
        width: max-content;
    }
`;

const TagName = styled(Card) <{ $darkMode?: boolean; }>`
    border: none !important;
    box-shadow: none !important;
    margin: 0px 0px 0px 10px !important;
    padding: 0px 10px !important;
    font-size: 10px !important;
    font-weight: 600 !important;
    font-style: oblique !important;
    align-content: center !important;
    border-radius: 10px !important;
    // color: #878a99 !important;
`;

const CustomExpirationDate = (fieldProps: CustomExpirationDateInterface) => {
    let isDarkMode = LocalStorageHelper.isDarkMode();
    let currentDate = new Date();
    let nextMonth = new Date();
    let _expirationDate = new Date(fieldProps?.expiryDate ?? new Date());

    nextMonth.setMonth(nextMonth.getMonth() + 1);
    
    let isExpired = currentDate > _expirationDate;
    let isExpiring = (_expirationDate < nextMonth  && _expirationDate > currentDate);

    return <ExpirationDateContainer $isFromDetails={fieldProps?.isFromDetails ?? false}>
        <Typography className="expirationDate" sx={{color: isExpired || isExpiring ? "errorText" : "primaryText"}}>{fieldProps?.expiryDate ? DateHelper.getFormattedDate(fieldProps?.expiryDate, "dd/MM/yyyy") : "--"}</Typography>
        {(isExpired || isExpiring) && <TagName sx={{backgroundColor: "customBorder.main", color: 'primaryText'}}>{isExpired ? 'Expired' : 'Expiring'}</TagName>}
    </ExpirationDateContainer>
}

export default CustomExpirationDate;